import React, { useEffect, useState, useRef, startTransition } from 'react';
import { useRunActivePanelMutation } from '../../Redux/StatCase/StatCaseSlice';
import { getWorkspaceData } from '../../Redux/Workspace/workspaceSlice';
import { useSelector } from 'react-redux';
import { date_mmddyy } from '../../Utils';
import { useRunGetStatCaseMutation } from '../../Redux/StatCase/StatCaseSlice';
import Dialog from '../../GenericComponents/dialog';
import { useStatPortalIdContext } from './StatCaseFormHooks/StatPortalIdContext';
import { FoundationsTextArea } from '../../GenericComponents/textarea';
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster';
import { WorkspaceApiDTO_Workspace } from '../../Interfaces/APIContracts/WorkspaceApiDTO_Workspace';
import { useWorkspaceStore } from '../../Pages/Workspace/workspaceContext';


interface StatCaseFormProps {
  runVUData: any;
  reasonForCall: string;
}

const StatCaseForm: React.FC<StatCaseFormProps> = ({
  runVUData,
  reasonForCall,
}) => {
  const {
    StatPortalId,
    selectedVuId,
    selectedAccessionNumber,
    action,
    setStatPortalId,
    trigger
  } = useStatPortalIdContext();
  const [RunGetStatCase] = useRunGetStatCaseMutation();

  const visualUnitId = runVUData.id;
  const [labelSiteName, setlabelSiteName] = useState('Case #');
  const [isAllowStatPortal, setIsisAllowStatPortal] = useState(false);
  const currentWorkspaceData: WorkspaceApiDTO_Workspace = useWorkspaceStore((s) => s.workspaceState);
  const currentdashBoardId = currentWorkspaceData?.WorkspaceId || '';
  const [permittedsitelist, setPermittedsitelist] = useState<any>([]);
  const [permittedsitecasetypes, setPermittedsitecasetypes] = useState<any[]>([]);
  const [currentpermittedsitecasetypes, setcurrentPermittedsitecasetypes] = useState<{ KeyValue: number, DisplayName: string }[]>([]);
  const [RunActivePanel, { error: runWorkListManagerError, isLoading: runWorkListManagerLoading }] =
    useRunActivePanelMutation();
  const [isSingleSite, setIsSingleSite] = useState(false);
  const [drInfo, setDrInfo] = useState('');
  const [cernerEnabledList, setCernerEnabledList] = useState<{ [key: string]: { iscerner: string, cernersiteprefix: string } }>({});
  const [remainigTechNotes, setRemainingTechNotes] = useState(500);
  const [showCaseNumberContatiner, setShowCaseNumberContainer] = useState(false);
  const [caseNumberDisplay, setCaseNumberDisplay] = useState('');
  const [isCernerCase, setIsCerner] = useState(false);
  const [isPastMidnight, setIsPastMidnight] = useState(false);

  const [dialogConfig, setDialogConfig] = useState({
    isOpen: false,
    type: '', // 'REJECT' or 'REOPEN'
    note: '',
    error: '',
  });
  const [validationErrors, setValidationErrors] = useState<{ [key: string]: string }>({});
  const [disableReady, setdisableReady] = useState(true);
  const [submitButtonLabel, setSubmitButtonLabel] = useState("Submit");
  const siteSelectRef = useRef<HTMLSelectElement | null>(null);
  let maxLength = (isSingleSite && isCernerCase) || (!isSingleSite && isCernerCase) ? 16 : 6;
  // Don't render if form isn't open
  // if (!isOpen) {
  //   return null;
  // }

  // Initialize form data with useState
  const [formData, setFormData] = useState(() => {
    return {
      txtCaseNumber: '',
      txtDrName: '',
      txtStudyDesc: '',
      txtTotalImage: '',
      patientLocation: '',
      technicalNotes: '',
      txtDate: date_mmddyy(new Date()),
      txtAreaCode: '',
      txtSubArea: '',
      txt4Number: '',
      txtXtension: '',
      RTAreaCode: '',
      RTSubArea: '',
      RT4Number: '',
      RTXtension: '',
      priority: 2 // initialize priority to 2 i.e - STAT
    };
  });

  // Utility function for phone number formatting
  const formatPhoneNumber = (phone: string) => {
    if (!phone) return { areaCode: '', subArea: '', number: '', extension: '' };
    return {
      areaCode: phone.substring(0, 3),
      subArea: phone.substring(3, 6),
      number: phone.substring(6, 10),
      extension: phone.substring(10),
    };
  };

  // Replace splitPhone with formatPhoneNumber
  const splitPhone = formatPhoneNumber;

  useEffect(() => {
    if (StatPortalId !== '') {
      getCaseDetails(selectedVuId, StatPortalId);
    }
  }, [StatPortalId, trigger]);

  const updateSubmitButtonState = (state: number) => {
    setSubmitButtonLabel(state > 2 ? "Reopen" : "Submit");
    if (state > 2) {
      setIsisAllowStatPortal(false);
    }
    if (state === 2) {
      setdisableReady(false);
    }else{
      setdisableReady(true);
    }
  };

  const getCaseDetails = async (vuId: Number, accessionNumber: string) => {
    try {
      const clientDtoRequest = {
        dashBoardId: currentdashBoardId,
        visualUnitId: vuId,
        reasonForCall: "GETCASE",
        accessionnumber: accessionNumber,
      };

      const response = await RunGetStatCase(clientDtoRequest).unwrap();

      if (response.data?.caselist?.length > 0) {
        const caseData = response.data.caselist[0];
        setIsisAllowStatPortal(response.data.AllowStatPortal);
        let index = -1;
        if (siteSelectRef.current) {
          index = permittedsitelist.findIndex(
            (site: any) => Number(site.key) === caseData.submittingsite_key
          );
          siteSelectRef.current.value = index !== -1 ? index.toString() : '-1';
        }
        // Split phone numbers
        const drPhone = formatPhoneNumber(caseData.doctorsphone);
        const rtPhone = formatPhoneNumber(caseData.RadTechphone);
        let accessionNumberPart = ""
        let date = ""
        if (!caseData.IsCerner) {
          date = accessionNumber.split('-')[1] || '';
          accessionNumberPart = accessionNumber.split('-')[2] || '';
        } else {
          setIsCerner(true);
          accessionNumberPart = caseData.accessionnumber || '';
        }

        // Update form data
        if (action !== 'RELEASE') {
          setFormData({
            txtCaseNumber: accessionNumberPart || "",
            txtDrName: caseData.doctorsname || "",
            txtStudyDesc: caseData.studyinfo || "",
            txtTotalImage: caseData.imagecount?.toString() || "",
            patientLocation: caseData.PatientLocation || "",
            technicalNotes: caseData.technotes || "",
            txtDate: date,
            txtAreaCode: drPhone.areaCode,
            txtSubArea: drPhone.subArea,
            txt4Number: drPhone.number,
            txtXtension: drPhone.extension,
            RTAreaCode: rtPhone.areaCode,
            RTSubArea: rtPhone.subArea,
            RT4Number: rtPhone.number,
            RTXtension: rtPhone.extension,
            priority: caseData.priority || 0,
          });

          // Scroll form into view
          const formElement = document.getElementById('dvMain');
          if (formElement) {
            formElement.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
            const firstInput = formElement.querySelector('input, select, textarea') as HTMLElement;
            if (firstInput) {
              firstInput.focus();
            }
          }

          // Update UI based on state
          updateSubmitButtonState(caseData.state);
        }
        return caseData;
      }
      return null;
    } catch (error) {
      console.error('Error fetching case details:', error);
      return null;
    }
  };

  const fetchCaseList = async () => {
    const reqRunVUData = {
      dashBoardId: currentdashBoardId,
      visualUnitId: visualUnitId,
      reasonForCall: reasonForCall,
    };
    try {
      const res = await RunActivePanel(reqRunVUData);
      const resultData = res.data.data;
      if (resultData.permittedsitelist.length === 1) {
        setIsSingleSite(true);
        setlabelSiteName(`${resultData.permittedsitelist[0].toString()} Case #`);

      }
      const sites = resultData.permittedsitelist.map((site: string, index: number) => ({
        key: resultData.permittedsitekeylist[index].toString(),
        name: site,
        sitecode: resultData.permittedsitecodes[index].toString(),
      }));
      setPermittedsitelist(sites);
      setIsCerner(false);
      if (
        resultData.permittedsitelist.length === 1 &&
        resultData.permittedsitecernerlist[0].toString().toLowerCase() === "true"
      ) {
        setlabelSiteName(`${resultData.permittedsitelist[0].toString()} Case #`);
        setFormData((prev) => ({
          ...prev,
          txtCaseNumber: resultData.permittedcernersitePrefix[0].toString(),
        }));
        setIsCerner(true);
      }

      const cernerList = resultData.permittedsitelist.reduce((acc: any, key: string, i: number) => {
        acc[i] = {
          iscerner: resultData.permittedsitecernerlist[i].toString(),
          cernersiteprefix: resultData.permittedcernersitePrefix[i].toString(),
        };
        return acc;
      }, {});
      const permittedCaseTypesList = resultData.permittedsitecasetypes.reduce((acc: any, key: string, i: number) => {
        const parsedKeys = JSON.parse(key); // Parse the JSON string into an array of objects
        acc[i] = parsedKeys.map((parsedKey: { KeyValue: number; DisplayName: string }) => ({
          KeyValue: parsedKey.KeyValue,
          DisplayName: parsedKey.DisplayName,
        }));
        return acc;
      }, {});
      setCernerEnabledList(cernerList);
      setPermittedsitecasetypes(permittedCaseTypesList);
      const newcasetypesallowed = JSON.parse(resultData.permittedsitecasetypes[0]);
      const selectedCaseTypes = (newcasetypesallowed).flatMap((nestedArray: any) => nestedArray);
      setcurrentPermittedsitecasetypes(selectedCaseTypes);
    } catch (error) {
      console.error("Error fetching Worklists:", error);
    }
  };

  useEffect(() => {
    fetchCaseList();
  }, [RunActivePanel, currentdashBoardId, reasonForCall, visualUnitId]);

  const generateDrInfo = () => {
    const drInfoContent = `Name: ${formData.txtDrName}<br/>Critical Callback#: ${formData.txtAreaCode}-${formData.txtSubArea}-${formData.txt4Number}x${formData.txtXtension}<br />Radiology Tech#: ${formData.RTAreaCode}-${formData.RTSubArea}-${formData.RT4Number}x${formData.RTXtension}<br />Tech Notes: ${formData.technicalNotes}`;
    setDrInfo(drInfoContent);
  };

  useEffect(() => {
    generateDrInfo();
  }, [formData]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name === 'technicalNotes') {
      setRemainingTechNotes(500 - e.currentTarget.value.length);
    }
    if (value.trim()) {
      setValidationErrors(prev => {
        const { [name]: removedError, ...rest } = prev; // Remove the specific field's error
        return rest;
      });
    }
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePriorityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const priority = parseInt(e.target.value);
    setFormData(prev => ({
      ...prev,
      priority: priority
    }));
  };

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const { maxLength, value, name } = e.currentTarget;
    if (value.length >= maxLength) {
      switch (name) {
        case 'txtAreaCode':
          document.getElementById('txtSubArea')?.focus();
          break;
        case 'txtSubArea':
          document.getElementById('txt4Number')?.focus();
          break;
        case 'txt4Number':
          document.getElementById('txtXtension')?.focus();
          break;
        case 'RTAreaCode':
          document.getElementById('RTSubArea')?.focus();
          break;
        case 'RTSubArea':
          document.getElementById('RT4Number')?.focus();
          break;
        case 'RT4Number':
          document.getElementById('RTXtension')?.focus();
          break;
        default:
          break;
      }
    }
  };

  const handleSiteChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedSite = Number(e.target.value);
    const siteInfo = cernerEnabledList[selectedSite];
    const isCerner = siteInfo?.iscerner?.toLowerCase() === 'true';
    const selectedCaseTypes = (permittedsitecasetypes[selectedSite] || []).flatMap((nestedArray: any) => nestedArray);
    setcurrentPermittedsitecasetypes(selectedCaseTypes);
    setValidationErrors((prev) => {
      const { ap_statcase_selectsite: removedError, ...rest } = prev;
      return rest;
    });

    if (isCerner) {
      setFormData(prev => ({
        ...prev,
        txtCaseNumber: siteInfo.cernersiteprefix,
      }));
      setIsCerner(true);
    } else {
      setIsCerner(false);
      maxLength = 6;  // state is async, so set maxLength here
      setFormData(prev => ({
        ...prev,
        txtDate: date_mmddyy(new Date()),
        txtCaseNumber: formData.txtCaseNumber.trim() === '' ? '' : formData.txtCaseNumber.substring(0, maxLength-1),
      }));
    }
  };


  useEffect(() => {
    const selectedindex = siteSelectRef.current?.value;
    let selectedSite = permittedsitelist[Number(selectedindex)];
    if (isSingleSite) {
      selectedSite = permittedsitelist[0];
    }
    let siteCode = selectedSite?.sitecode || '';
    const date = formData.txtDate;
    const caseNumber = formData.txtCaseNumber;
    if (isCernerCase && caseNumber.length >= 5 && siteCode !== "") {
      setCaseNumberDisplay(`${siteCode}-${caseNumber}`);
      setShowCaseNumberContainer(true);
    } else if (!isCernerCase && (siteCode !== "" || caseNumber !== "")){
      setCaseNumberDisplay(`${siteCode}-${date}-${caseNumber}`);
      setShowCaseNumberContainer(true);
    }
    
  }, [formData.txtCaseNumber, formData.txtDate, siteSelectRef.current?.value, isCernerCase]);

  const handleDialogAction = async () => {
    try {
      if (!dialogConfig.note.trim()) {
        setDialogConfig(prev => ({
          ...prev,
          error: `Please enter a reason you wish to reject/return the case.`
        }));
        return;
      }
      let selectedSite
      let siteName
      let siteCode
      if (isSingleSite) {
        selectedSite = permittedsitelist[0];
      }
      else {
        selectedSite = permittedsitelist[Number(siteSelectRef.current?.value)];
      }
      // Use formData for constructing the payload
      siteCode = selectedSite?.sitecode || '';
      siteName = selectedSite.name;
      let site_key = selectedSite.key || -1;
      let accessionNumber = isCernerCase ? `${siteName}-${formData.txtCaseNumber}` : `${siteName}-${formData.txtDate}-${formData.txtCaseNumber}`;

      const drPhone = `${formData.txtAreaCode}${formData.txtSubArea}${formData.txt4Number}${formData.txtXtension}`;
      const rtPhone = `${formData.RTAreaCode}${formData.RTSubArea}${formData.RT4Number}${formData.RTXtension}`;
      const notes = `REASON ${dialogConfig.type === 'REJECT' ? 'RETURNED' : 'REOPENED'}: ${dialogConfig.note}\n-----\n${formData.technicalNotes}`;

      const submissionData = {
        studyinfo: formData.txtStudyDesc,
        accessionnumber: accessionNumber,
        imagecount: parseInt(formData.txtTotalImage) || 0,
        doctorsname: formData.txtDrName,
        doctorsphone: drPhone,
        RadTechphone: rtPhone,
        PatientLocation: formData.patientLocation,
        doctorspager: "",
        technotes: notes,
        superstat: formData.priority > 2,
        priority: formData.priority,
        sitecode: siteCode,
        site_key: site_key,
        site_name: siteName,
        sitecode3: siteName,
        datecode6digit: formData.txtDate,
        rawcasenumber: formData.txtCaseNumber,
        reasonForCall: dialogConfig.type,
        dashBoardId: currentdashBoardId,
        visualUnitId: Number(runVUData.id),
        state: dialogConfig.type === 'REJECT' ? 3 : 0
      };

      const response = await RunActivePanel(submissionData).unwrap();
      if (response.statusCode === 201) {
        setDialogConfig({ isOpen: false, type: '', note: '', error: '' });
        handleClear();
      }
    } catch (error) {
      console.error(`Error ${dialogConfig.type.toLowerCase()}ing case:`, error);
    }
  };

  const handleRejectClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault();
    setDialogConfig({
      isOpen: true,
      type: 'REJECT',
      note: '',
      error: ''
    });
  };

  const handleReopenClick = () => {
    setDialogConfig({
      isOpen: true,
      type: 'REOPEN',
      note: '',
      error: ''
    });
  };

  const missingInfo = (field: string, message: string) => {
    setValidationErrors(prev => ({
      ...prev,
      [field]: message
    }));
    const element = document.getElementById(field);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      element.focus();
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    try {
      e.preventDefault();
      let accessionNumber
      let drPhone
      let rtPhone
      let selectedSite
      let site_key
      let siteName
      let siteCode
      if (submitButtonLabel === "Reopen") {
        handleReopenClick()
      } else {

        // Validate required fields

        if (isSingleSite) {
          selectedSite = permittedsitelist[0];
        }
        else {
          selectedSite = permittedsitelist[Number(siteSelectRef.current?.value)];
          if (selectedSite === undefined) {
            missingInfo('ap_statcase_selectsite', 'Please enter a site code.');
            return;
          }
        }
        if (!isCernerCase && (!formData.txtDate.trim() || (/^\d+$/.test(formData.txtDate) === false) || Number(formData.txtDate) <= 0)) {
          missingInfo('txtDate', 'Please enter valid date of study');
          return;
        }
        const casenumber = formData.txtCaseNumber.trim();
        if (casenumber === "" || !/^[a-z0-9]+$/gi.test(casenumber)) {
          missingInfo('txtCaseNumber', 'Please enter valid case number.');
          return;
        }
        if (!formData.txtStudyDesc.trim()) {
          missingInfo('txtStudyDesc', 'Please enter a study description.');
          return;
        }
        if (!formData.txtTotalImage.trim() || isNaN(Number(formData.txtTotalImage))) {
          missingInfo('txtTotalImage', 'Please enter a numeric value for number of images.');
          return;
        }
        if (!formData.txtAreaCode.trim()) {
          missingInfo('txtAreaCode', 'Please enter area code for doctors phone number.');
          return;
        }
        if (!formData.txtSubArea.trim()) {
          missingInfo('txtSubArea', 'Please enter doctors phone number.');
          return;
        }
        if (!formData.txt4Number.trim()) {
          missingInfo('txt4Number', 'Please enter doctors phone number.');
          return;
        }
        if (!formData.RTAreaCode.trim()) {
          missingInfo('RTAreaCode', 'Please enter area code for Radiology Tech phone number.');
          return;
        }
        if (!formData.RTSubArea.trim()) {
          missingInfo('RTSubArea', 'Please enter Radiology Tech phone number.');
          return;
        }
        if (!formData.RT4Number.trim()) {
          missingInfo('RT4Number', 'Please enter Radiology Tech phone number.');
          return;
        }

        // Clear validation errors if all fields are valid
        setValidationErrors({});
        siteName = selectedSite.name || '';
        siteCode = selectedSite?.sitecode || '';
        site_key = selectedSite.key || -1;

        // const accessionNumber = isSingleSite
        //   ? formData.caseNumber
        //   : isCerner
        //     ? `${selectedSite}-${formData.caseNumber}`
        //     : `${selectedSite}-${formData.date}-${formData.caseNumber}`;
        accessionNumber = isCernerCase ? `${siteName}-${formData.txtCaseNumber}` : `${siteName}-${formData.txtDate}-${formData.txtCaseNumber}`;

        drPhone = `${formData.txtAreaCode}${formData.txtSubArea}${formData.txt4Number}${formData.txtXtension}`;
        rtPhone = `${formData.RTAreaCode}${formData.RTSubArea}${formData.RT4Number}${formData.RTXtension}`;
      }
      const submissionData = {
        studyinfo: formData.txtStudyDesc,
        accessionnumber: accessionNumber,
        imagecount: parseInt(formData.txtTotalImage) || 0,
        doctorsname: formData.txtDrName,
        doctorsphone: drPhone,
        RadTechphone: rtPhone,
        Patientlocation: formData.patientLocation,
        doctorspager: "",
        technotes: formData.technicalNotes,
        superstat: formData.priority > 2,
        priority: formData.priority,
        sitecode: siteCode,
        site_key: site_key,
        site_name: siteName,
        sitecode3: siteName,
        datecode6digit: formData.txtDate,
        rawcasenumber: isCernerCase ? formData.txtCaseNumber.substring(5) : formData.txtCaseNumber,
        reasonForCall: "SUBMIT",
        dashBoardId: currentdashBoardId,
        visualUnitId: Number(runVUData.id)
      };

      const response = await RunActivePanel(submissionData).unwrap();
      if (response.statusCode === 201) {
        FoundationsGenericToaster('success', 'Case submitted successfully')
        handleClear();
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const handleReady = async (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault();
    try {
      let selectedSite
      let siteName
      let siteCode
      if (isSingleSite) {
        selectedSite = permittedsitelist[0];
      }
      else {
        selectedSite = permittedsitelist[Number(siteSelectRef.current?.value)];
      }
      siteName = selectedSite.name || '';
      siteCode = selectedSite?.sitecode || '';
      let site_key = selectedSite.key || -1;
      let accessionNumber = isCernerCase ? `${siteName}-${formData.txtCaseNumber}` : `${siteName}-${formData.txtDate}-${formData.txtCaseNumber}`;
      const drPhone = `${formData.txtAreaCode}${formData.txtSubArea}${formData.txt4Number}${formData.txtXtension}`;
      const rtPhone = `${formData.RTAreaCode}${formData.RTSubArea}${formData.RT4Number}${formData.RTXtension}`;

      const submissionData = {
        studyinfo: formData.txtStudyDesc,
        accessionnumber: accessionNumber,
        imagecount: parseInt(formData.txtTotalImage) || 0,
        doctorsname: formData.txtDrName,
        doctorsphone: drPhone,
        RadTechphone: rtPhone,
        Patientlocation: formData.patientLocation,
        doctorspager: "",
        technotes: formData.technicalNotes,
        superstat: formData.priority > 2,
        priority: formData.priority,
        sitecode: siteCode,
        site_key: site_key,
        site_name: siteName,
        sitecode3: siteName,
        datecode6digit: formData.txtDate,
        rawcasenumber: formData.txtCaseNumber,
        reasonForCall: "READY",
        dashBoardId: currentdashBoardId,
        visualUnitId: Number(runVUData.id),
        state: 2
      };

      const response = await RunActivePanel(submissionData).unwrap();
      if (response.statusCode === 201) {
        handleClear();
      }
    } catch (error) {
      console.error('Error setting case to ready:', error);
    }
  };

  const handleClear = async (e?: React.MouseEvent<HTMLInputElement>) => {
    e?.preventDefault();
    startTransition(() => {
    setShowCaseNumberContainer(false);
    setFormData({
      txtCaseNumber: '',
      txtDrName: '',
      txtStudyDesc: '',
      txtTotalImage: '',
      patientLocation: '',
      technicalNotes: '',
      txtDate: date_mmddyy(new Date()),
      txtAreaCode: '',
      txtSubArea: '',
      txt4Number: '',
      txtXtension: '',
      RTAreaCode: '',
      RTSubArea: '',
      RT4Number: '',
      RTXtension: '',
      priority: 2,
    });
    setSubmitButtonLabel("Submit");
    setIsSingleSite(false);
    setRemainingTechNotes(500);
    setDrInfo('');
    setIsisAllowStatPortal(false);
    setValidationErrors({});
    setStatPortalId('');
    const form = document.querySelector('form');
    if (form) {
      form.reset();
    }
    if (siteSelectRef.current) {
      siteSelectRef.current.value = '-1';
    }
  })
   await fetchCaseList();
  };

  useEffect(() => {
    if (selectedVuId && selectedAccessionNumber && action === 'CLAIM') {
      claimClick(selectedVuId, selectedAccessionNumber);
    } else if (selectedVuId && selectedAccessionNumber && action === 'RELEASE') {
      releaseClick(selectedVuId, selectedAccessionNumber);
    }
  }, [selectedVuId, selectedAccessionNumber]);



  const claimClick = async (vuId: Number, accessionNumber: string) => {
    const response = await getCaseDetails(vuId, accessionNumber);
    try {
      if (response) {
        const siteCode = response.site_name || accessionNumber.substring(0, 3);
        const site_key = response.submittingsite_key || -1;

        const claimPayload = {
          studyinfo: response.studyinfo || "",
          accessionnumber: accessionNumber,
          imagecount: response.imagecount || 0,
          doctorsname: response.doctorsname || "",
          doctorsphone: response.doctorsphone || "",
          RadTechphone: response.RadTechphone || "",
          PatientLocation: response.PatientLocation || "",
          doctorspager: response.doctorspager || "",
          technotes: response.technotes || "",
          superstat: response.superstat || false,
          priority: response.priority || 0,
          sitecode: siteCode,
          site_key: site_key,
          site_name: response.site_name || "",
          sitecode3: siteCode,
          rawcasenumber: accessionNumber.substring(3),
          reasonForCall: "CLAIM",
          dashBoardId: currentdashBoardId,
          visualUnitId: vuId,
          state: 1
        };

        await RunActivePanel(claimPayload).unwrap();
        setStatPortalId(accessionNumber);
      }
    } catch (error) {
      console.error('Failed to claim case:', error);
    }
  };

  const releaseClick = async (vuId: Number, accessionNumber: string) => {
    const response = await getCaseDetails(vuId, accessionNumber);
    try {
      if (response) {
        const siteCode = response.site_name || accessionNumber.substring(0, 3);
        const site_key = response.submittingsite_key || -1;

        const releasePayload = {
          studyinfo: response.studyinfo || "",
          accessionnumber: accessionNumber,
          imagecount: response.imagecount || 0,
          doctorsname: response.doctorsname || "",
          doctorsphone: response.doctorsphone || "",
          RadTechphone: response.RadTechphone || "",
          PatientLocation: response.PatientLocation || "",
          doctorspager: response.doctorspager || "",
          technotes: response.technotes || "",
          superstat: response.superstat || false,
          priority: response.priority || 0,
          sitecode: siteCode,
          site_key: site_key,
          site_name: response.site_name || "",
          sitecode3: siteCode,
          rawcasenumber: accessionNumber.substring(3),
          reasonForCall: "RELEASE",
          dashBoardId: currentdashBoardId,
          visualUnitId: vuId,
          state: 0
        };

        await RunActivePanel(releasePayload).unwrap();
        if (StatPortalId === accessionNumber) {
          setStatPortalId("");
          handleClear();
        }
      }
    } catch (error) {
      console.error('Failed to release case:', error);
    }
  };
  useEffect(() => {
    const date = new Date();
    if (date.getHours() < 1 && date.getMinutes() <= 30) {
      setIsPastMidnight(true);
    }
  }, []);

  return (
    <>
      <form className="" noValidate>
        <div id='dvMain' className="dashboard-vu-data">
          <div style={{ padding: '1% 1% 1% 1%' }}>
            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td style={{ width: '15%' }} id='labelSiteName'>{labelSiteName}
                    {isPastMidnight && <div className="text-red">Note: It is a litte past midnight. Please double check the date part of your case number</div>}
                  </td>
                  <td style={{ width: '20%' }}>
                    <span id='txtAccessionNumber'>
                      {!isSingleSite && (
                        <select
                          id="ap_statcase_selectsite"
                          ref={siteSelectRef}
                          tabIndex={13}
                          size={1}
                          style={{ width: '90%' }}
                          onChange={handleSiteChange}
                          className={validationErrors['ap_statcase_selectsite'] ? 'error-highlight' : ''}
                        >
                          {!isSingleSite && permittedsitelist.length > 1 && (
                            <>
                              <option key={-1} value="-1" disabled selected>
                                - select a site -
                              </option>
                              {permittedsitelist.map((site: any, index: number) => (
                                <option key={index} value={index}>
                                  {site.name}
                                </option>
                              ))}
                            </>
                          )}
                        </select>
                      )}
                      {validationErrors['ap_statcase_selectsite'] && (
                        <div className="error-text">{validationErrors['ap_statcase_selectsite']}</div>
                      )}
                      {(isSingleSite && !isCernerCase) || (!isSingleSite && !isCernerCase) ? (
                        <>
                          <input
                            style={{ width: '36%' }}
                            type='text'
                            id='txtDate'
                            name='txtDate'
                            value={formData.txtDate}
                            onChange={handleInputChange}
                            maxLength={6}
                            tabIndex={3}
                            required
                            className={validationErrors['txtDate'] ? 'error-highlight' : ''}
                          />
                          <span id="spnaccno" className="statcase_form_seperator">-</span>
                        </>
                      ) : null}
                      <input
                        style={{ width: isSingleSite ? '144px' : (isCernerCase ? '155px' : '144px') }}
                        type="text"
                        id="txtCaseNumber"
                        name="txtCaseNumber"
                        value={formData.txtCaseNumber}
                        onChange={handleInputChange}
                        maxLength={maxLength}
                        tabIndex={4}
                        required
                        className={validationErrors['txtCaseNumber'] ? 'error-highlight' : ''}
                      />
                      {validationErrors['txtCaseNumber'] && (
                        <div className="error-text">{validationErrors['txtCaseNumber']}</div>
                      )}
                      {validationErrors['txtDate'] && (
                        <div className="error-text">{validationErrors['txtDate']}</div>
                      )}
                    </span>
                  </td>
                  <td style={{ width: '10%' }}>Dr. Name:</td>
                  <td style={{ width: '26%' }}>
                    <input
                      type="text"
                      id="txtDrName"
                      name="txtDrName"
                      value={formData.txtDrName}
                      onChange={handleInputChange}
                      maxLength={50}
                      tabIndex={7}
                      className={`statcase_form_input_widget ${validationErrors['txtDrName'] ? 'error-highlight' : ''}`}
                      required
                    />
                    {validationErrors['txtDrName'] && (
                      <div className="error-text">{validationErrors['txtDrName']}</div>
                    )}
                  </td>
                  <td
                    id='dvHelpText'
                    style={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', width: '28%', paddingLeft: '10px', verticalAlign: 'text-top', border: 'solid 1px #d7d7d7' }}
                    className="w-[28%] pl-2.5 align-top border border-gray-300"
                    rowSpan={4}
                    dangerouslySetInnerHTML={{ __html: drInfo }}
                  >
                  </td>
                </tr>

                <tr>
                  <td>Study Description:</td>
                  <td>
                    <input
                      type="text"
                      id="txtStudyDesc"
                      name="txtStudyDesc"
                      value={formData.txtStudyDesc}
                      onChange={handleInputChange}
                      maxLength={80}
                      tabIndex={4}
                      className={`statcase_form_input_widget ${validationErrors['txtStudyDesc'] ? 'error-highlight' : ''}`}
                      required
                    />
                    {validationErrors['txtStudyDesc'] && (
                      <div className="error-text">{validationErrors['txtStudyDesc']}</div>
                    )}
                  </td>
                  <td>Critical Callback#:</td>
                  <td style={{ width: '20%' }}>
                    <div id='txtDrPhone'>
                      <input
                        style={{ width: '15%' }}
                        type='text'
                        id='txtAreaCode'
                        name='txtAreaCode'
                        value={formData.txtAreaCode}
                        onChange={handleInputChange}
                        onKeyUp={handleKeyUp}
                        maxLength={3}
                        tabIndex={8}
                        required
                        className={validationErrors['txtAreaCode'] ? 'error-highlight' : ''}
                      />
                      <span className='statcase_form_seperator'>-</span>
                      <input
                        style={{ width: '15%' }}
                        type='text'
                        id='txtSubArea'
                        name='txtSubArea'
                        value={formData.txtSubArea}
                        onChange={handleInputChange}
                        onKeyUp={handleKeyUp}
                        maxLength={3}
                        tabIndex={9}
                        required
                        className={validationErrors['txtSubArea'] ? 'error-highlight' : ''}
                      />
                      <span className='statcase_form_seperator'>-</span>
                      <input
                        style={{ width: '20%' }}
                        type='text'
                        id='txt4Number'
                        name='txt4Number'
                        value={formData.txt4Number}
                        onChange={handleInputChange}
                        onKeyUp={handleKeyUp}
                        maxLength={4}
                        tabIndex={10}
                        required
                        className={validationErrors['txt4Number'] ? 'error-highlight' : ''}
                      />
                      <span className='statcase_form_seperator'>X</span>
                      <input
                        style={{ width: '28%' }}
                        type='text'
                        id='txtXtension'
                        name='txtXtension'
                        value={formData.txtXtension}
                        onChange={handleInputChange}
                        onKeyUp={handleKeyUp}
                        maxLength={6}
                        tabIndex={11}
                        required
                        className={validationErrors['txtXtension'] ? 'error-highlight' : ''}
                      />
                      {(validationErrors['txtAreaCode'] || validationErrors['txtSubArea'] || validationErrors['txt4Number']) && (
                        <div className="error-text">
                          {validationErrors['txtAreaCode'] || validationErrors['txtSubArea'] || validationErrors['txt4Number']}
                        </div>
                      )}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>No. of Images:</td>
                  <td>
                    <input
                      type="text"
                      id="txtTotalImage"
                      name="txtTotalImage"
                      value={formData.txtTotalImage}
                      onChange={handleInputChange}
                      maxLength={6}
                      tabIndex={5}
                      className={`statcase_form_input_widget ${validationErrors['txtTotalImage'] ? 'error-highlight' : ''}`}
                      required
                    />
                    {validationErrors['txtTotalImage'] && (
                      <div className="error-text">{validationErrors['txtTotalImage']}</div>
                    )}
                  </td>
                  <td>Radiology Tech#:</td>
                  <td style={{ width: '20%' }}>
                    <div id='RadTechPhone'>
                      <input
                        style={{ width: '15%' }}
                        type='text'
                        id='RTAreaCode'
                        name='RTAreaCode'
                        value={formData.RTAreaCode}
                        onChange={handleInputChange}
                        onKeyUp={handleKeyUp}
                        maxLength={3}
                        tabIndex={12}
                        required
                        className={validationErrors['RTAreaCode'] ? 'error-highlight' : ''}
                      />
                      <span className='statcase_form_seperator'>-</span>
                      <input
                        style={{ width: '15%' }}
                        type='text'
                        id='RTSubArea'
                        name='RTSubArea'
                        value={formData.RTSubArea}
                        onChange={handleInputChange}
                        onKeyUp={handleKeyUp}
                        maxLength={3}
                        tabIndex={13}
                        required
                        className={validationErrors['RTSubArea'] ? 'error-highlight' : ''}
                      />
                      <span className='statcase_form_seperator'>-</span>
                      <input
                        style={{ width: '20%' }}
                        type='text'
                        id='RT4Number'
                        name='RT4Number'
                        value={formData.RT4Number}
                        onChange={handleInputChange}
                        onKeyUp={handleKeyUp}
                        maxLength={4}
                        tabIndex={14}
                        required
                        className={validationErrors['RT4Number'] ? 'error-highlight' : ''}
                      />
                      <span className='statcase_form_seperator'>X</span>
                      <input
                        style={{ width: '28%' }}
                        type='text'
                        id='RTXtension'
                        name='RTXtension'
                        value={formData.RTXtension}
                        onChange={handleInputChange}
                        onKeyUp={handleKeyUp}
                        maxLength={6}
                        tabIndex={15}
                        required
                        className={validationErrors['RTXtension'] ? 'error-highlight' : ''}
                      />
                      {(validationErrors['RTAreaCode'] || validationErrors['RT4Number'] || validationErrors['RTSubArea']) && (
                        <div className="error-text">
                          {validationErrors['RTAreaCode'] || validationErrors['RT4Number'] || validationErrors['RTSubArea']}
                        </div>
                      )}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td style={{ display: 'none' }}>No. of Priors:</td>
                  <td style={{ display: 'none' }}>
                    <input
                      type="text"
                      id="txtNoOfPriors"
                      name="txtNoOfPriors"
                      maxLength={2}
                      tabIndex={6}
                      required
                      className="statcase_form_input_widget"
                    />
                  </td>
                  <td>Patient Location</td>
                  <td>
                    <input
                      type="text"
                      id="PatientLocation"
                      name="patientLocation"
                      value={formData.patientLocation}
                      onChange={handleInputChange}
                      maxLength={50}
                      tabIndex={6}
                      className={`statcase_form_input_widget ${validationErrors['PatientLocation'] ? 'error-highlight' : ''}`}
                      required
                    />
                    {validationErrors['PatientLocation'] && (
                      <div className="error-text">{validationErrors['PatientLocation']}</div>
                    )}
                  </td>
                  <td>Priority:</td>
                  <td>
                    <select
                      id="ap_statcase_criticaltype"
                      onChange={handlePriorityChange}
                      tabIndex={13}
                      size={1}
                      value={formData.priority !== 0 ? formData.priority : (currentpermittedsitecasetypes[0]?.KeyValue || '')}
                      className={validationErrors['ap_statcase_criticaltype'] ? 'error-highlight' : ''}
                    >
                      {currentpermittedsitecasetypes.map((casetype, index) => (
                        <option key={index} value={casetype.KeyValue}>
                          {casetype.DisplayName}
                        </option>
                      ))}
                    </select>
                    {validationErrors['ap_statcase_criticaltype'] && (
                      <div className="error-text">{validationErrors['ap_statcase_criticaltype']}</div>
                    )}
                  </td>
                </tr>

                <tr>
                  <td id='techNoteLabel' style={{ verticalAlign: 'top' }}>
                    <span>Technical Notes:</span><br />
                    {remainigTechNotes !== 500 && <span style={{ fontSize: '10px' }} id="txtTechNotesRemainingLabel">{remainigTechNotes + ' characters remaining'}</span>}
                  </td>
                  <td colSpan={3}>
                    <textarea
                      id="txtTechnicalNotes"
                      name="technicalNotes"
                      value={formData.technicalNotes}
                      onChange={handleInputChange}
                      rows={6}
                      tabIndex={14}
                      maxLength={500}
                      style={{ width: '95.5%' }}
                      className={validationErrors['txtTechnicalNotes'] ? 'error-highlight' : ''}
                    />
                    {validationErrors['txtTechnicalNotes'] && (
                      <div className="error-text">{validationErrors['txtTechnicalNotes']}</div>
                    )}
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          {showCaseNumberContatiner && <td id='caseNumberContainer' className='ajax-page-success text-red' colSpan={3}>Please confirm the Case Number:
                            <u id='statCaseNumber'>{caseNumberDisplay}</u>
                          </td>
                          }
                        </tr>
                        {isAllowStatPortal && <tr>
                          <td>
                            {disableReady &&
                              <input
                                tabIndex={17}
                                type='button'
                                value="Ready"
                                title="Accept this case"
                                style={{ borderTopColor: "green", borderLeftColor: "green", width: "70px", height: "30px" }}
                                onClick={(e) => handleReady(e)}
                              />
                            }
                          </td>
                          <td></td>
                          <td>
                            <input
                              tabIndex={18}
                              type='button'
                              value="Reject"
                              title="Send this case back"
                              style={{ borderRightColor: "red", borderBottomColor: "red", width: "70px", height: "30px" }}
                              onClick={(e) => handleRejectClick(e)}
                            />
                          </td>
                        </tr>
                        }
                        <tr>
                          <td style={{ width: "40%" }}>
                            <input
                              id="btnSubmit"
                              type="button"
                              value={submitButtonLabel}
                              tabIndex={15}
                              style={{ width: "70px", height: "30px" }}
                              onClick={(e) => handleSubmit(e)}
                            />
                          </td>
                          <td style={{ width: "10%" }}></td>
                          <td style={{ width: "40%" }}>
                            <input
                              tabIndex={16}
                              type='button'
                              value="Clear"
                              style={{ width: "70px", height: "30px" }}
                              onClick={(e) => handleClear(e)}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </form>
      <Dialog
        isOpen={dialogConfig.isOpen}
        onClose={() => setDialogConfig({ isOpen: false, type: '', note: '', error: '' })}
        title={`${dialogConfig.type === 'REJECT' ? 'Reject' : 'Reopen'} Case`}
        width={320}
        modal={true}
        buttons={[
          {
            label: 'Cancel',
            onClick: () => setDialogConfig({ isOpen: false, type: '', note: '', error: '' }),
            className: 'app-button negative'
          },
          {
            label: `${dialogConfig.type === 'REJECT' ? 'Reject' : 'Reopen'} Case`,
            onClick: handleDialogAction,
            className: 'app-button'
          }
        ]}
      >
        <div id='hl_ui_editbox'>
          {dialogConfig.error && (
            <div style={{ marginBottom: '1rem', color: 'red' }}>{dialogConfig.error}</div>
          )}

          <FoundationsTextArea
            id='hl_ui_editbox_area'
            inputClasses='field-add-new-dashboard'
            value={dialogConfig.note}
            onInput={(e: { target: { value: any; }; }) => setDialogConfig(prev => ({ ...prev, note: e.target.value }))}
            rows={6}
            cols={40}
            placeHolder={`Enter reason for ${dialogConfig.type.toLowerCase()}ing...`}
            containerClasses='w-full d-block'
          />
        </div>
      </Dialog>
      <style>
        {`
          .error-border {
            border: 1px solid red;
          }
          .error-highlight {
            background-color: #FFFF99; /* Light yellow background */
            border: 1px solid #FFA500; /* Orange border */
          }
          .error-text {
            color: red;
            font-size: 12px;
          }
        `}
      </style>
    </>
  );
};

export default StatCaseForm;